var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.333,
    height: 26.333,
    viewBox: "0 0 26.333 26.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(10 10)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M21.351,16.485a1.825,1.825,0,0,0,.365,2.013l.066.066a2.213,2.213,0,1,1-3.13,3.13l-.066-.066a1.84,1.84,0,0,0-3.119,1.305v.188a2.212,2.212,0,0,1-4.424,0v-.1a1.825,1.825,0,0,0-1.195-1.67,1.825,1.825,0,0,0-2.013.365l-.066.066a2.213,2.213,0,1,1-3.13-3.13l.066-.066A1.84,1.84,0,0,0,3.4,15.467H3.212a2.212,2.212,0,1,1,0-4.424h.1a1.825,1.825,0,0,0,1.67-1.195,1.825,1.825,0,0,0-.365-2.013L4.55,7.769a2.213,2.213,0,1,1,3.13-3.13l.066.066A1.825,1.825,0,0,0,9.76,5.07h.088A1.825,1.825,0,0,0,10.954,3.4V3.212a2.212,2.212,0,1,1,4.424,0v.1A1.84,1.84,0,0,0,18.5,4.617l.066-.066a2.213,2.213,0,1,1,3.13,3.13l-.066.066a1.825,1.825,0,0,0-.365,2.013v.088a1.825,1.825,0,0,0,1.67,1.106h.188a2.212,2.212,0,0,1,0,4.424h-.1A1.825,1.825,0,0,0,21.351,16.485Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.81238ce0b8ace4843409a655665cdaf9.svg";
export { ForwardRef as ReactComponent };